import { render, staticRenderFns } from "./AudienceTransfer.vue?vue&type=template&id=6f813f72"
import script from "./AudienceTransfer.vue?vue&type=script&lang=js"
export * from "./AudienceTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports